import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import DrawerMenuItem from './DrawerMenuItem';

function DrawerMenuExternalLink({
  externalLink,
  ariaLabel = 'Show more information',
  ...otherProps
}) {
  return (
    <DrawerMenuItem
      {...otherProps}
      buttonComponent="a"
      buttonProps={{
        target: '_blank',
        href: externalLink,
        rel: 'noopener',
      }}
      rightIcon={OpenInNewIcon}
      ariaLabel={ariaLabel}
    />
  );
}

export default DrawerMenuExternalLink;
